import find from 'lodash/find';
import lowerFirst from 'lodash/lowerFirst';

import { Axios, AxiosService } from '@/services/Axios';
import { DictionaryDTO } from '@/types';

class DictionaryControllerClass {
  constructor(private APIService: AxiosService) {}

  convertFromAPIDataToReduxData = (
    dictionariesList: DictionaryDTO[],
    defaultDictionaryIsRequired = true,
  ): DictionaryDTO[] => {
    // Replace non-boolean 'default' property's value with false
    dictionariesList = dictionariesList.map(dictionary => ({
      ...dictionary,
      id: Number(dictionary.id),
      default: dictionary.default || false,
    }));

    // If there is no a single default dictionary -> set the first dictionary as default one
    if (defaultDictionaryIsRequired && find(dictionariesList, { default: true }) === undefined) {
      const [first, ...rest] = dictionariesList;

      return [{ ...first, default: true }, ...rest];
    }

    return dictionariesList;
  };

  fetchDictionary = (instance: string, dictionaryName: string) => {
    return this.APIService.get(`/${instance}/${dictionaryName}`);
  };

  fetchOrderDictionary = (name: string) => {
    return this.fetchDictionary('orders', `${lowerFirst(name)}`);
  };

  fetchOpportunityDictionary = (name: string) => {
    return this.fetchDictionary('opportunities', `${lowerFirst(name)}`);
  };

  fetchRequestNewProposalReasons = () => {
    return this.APIService.get('opportunities/newProposalReasonType');
  };

  fetchProposalItems = (proposalId: string) => {
    return this.APIService.get(`proposals/${proposalId}/items`);
  };
}

export const DictionaryController = new DictionaryControllerClass(Axios);
